export const font = {
  title: {
    family: 'Poppins',
    size: {
      h1: '22px',
      h2: '20px',
      h3: '18px',
      h4: '16px',
    },
    weight: {
      bold: 700,
      semi: 600,
      regular: 500,
    },
    lineHeight: {
      h1: '33px',
      h2: '30px',
      h3: '27px',
      h4: '24px',
    },
  },
  body: {
    family: 'Montserrat',
    size: {
      h2: '20px',
      regular: '16px',
      small: '14px',
    },
    weight: {
      bold: 700,
      regular: 400,
    },
    lineHeight: {
      h2: '24.38px',
      bold: '19.5px',
      regular: '27px',
      small: '17.07px',
    },
  },
};
